import axiosClient from "./axiosClient";

export async function getMyProfile() {
  const response = await axiosClient.get("/Users/me");
  return response.data;
}

export async function updatePhone(phone) {
  const response = await axiosClient.put("/Users/phone", { phone });
  return response.data;
}

export async function updateFullName(fullName) {
  const response = await axiosClient.put("/Users/full-name", { fullName });
  return response.data;
}

export async function updateMarketingOptIn(marketingOptIn) {
  const response = await axiosClient.put("/Users/marketing-opt-in", { marketingOptIn });
  return response.data;
}

export async function uploadProfileImage(file) {
  const formData = new FormData();
  formData.append("file", file);
  const response = await axiosClient.post("/Users/profile-image", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
}
